<div class="date-info-container">
    <div *ngIf="!hideLabel" class="date-info-container__label">
        {{ label }}
    </div>
    <div class="date-info-container__info">
        {{ fieldControl.value | date: 'EEEE, dd/MM/yyyy' }}
    </div>
</div>

